import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {useNavigate, useSearchParams} from '@github-ui/use-navigate'
import {Pagination} from '@primer/react'
import {useCallback} from 'react'

import {VALUES} from './constants/values'

export const MilestoneListPagination = ({dataCount}: {dataCount: number}) => {
  const PAGE_SIZE = VALUES.milestonePageSize
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const pageParam = searchParams.get('page')
  const parsedPage = pageParam ? parseInt(pageParam, 10) : 1
  const pageCount = Math.max(1, Math.ceil(dataCount / PAGE_SIZE))
  const requestedPage = Number.isNaN(parsedPage) ? 1 : Math.max(1, parsedPage)
  const currentPage = Math.min(requestedPage, pageCount)

  const handlePageChange = useCallback(
    (e: React.MouseEvent, page_number: number) => {
      e.preventDefault()
      if (page_number === currentPage) return
      const params = new URLSearchParams(searchParams)
      params.set('page', page_number.toString())

      const href = `${ssrSafeWindow?.location.pathname ?? ''}?${params.toString()}`
      navigate(href)
    },
    [navigate, searchParams, currentPage],
  )

  const hrefBuilder = useCallback(
    (page_number: number) => {
      const params = new URLSearchParams(searchParams)
      params.set('page', page_number.toString())
      return `${ssrSafeWindow?.location.pathname ?? ''}?${params.toString()}`
    },
    [searchParams],
  )

  return (
    <Pagination
      pageCount={pageCount}
      hrefBuilder={hrefBuilder}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  )
}
